import {Component, Input} from "@angular/core";

@Component({
    selector: 'db-rating-stars',
    templateUrl: './rating-stars.component.html',
    styleUrls: ['./rating-stars.component.scss'],
    standalone: false
})
export class RatingStarsComponent {

  @Input() rating: number;
  @Input() centered: boolean;

  public stars = [];
  public starsWidth = {
    0.5: [50, 0, 0, 0, 0],
    1: [100, 0, 0, 0],
    1.5: [100, 50, 0, 0, 0],
    2: [100, 100, 0, 0, 0],
    2.5: [100, 100, 50, 0, 0],
    3: [100, 100, 100, 0, 0],
    3.5: [100, 100, 100, 50, 0],
    4: [100, 100, 100, 100, 0],
    4.5: [100, 100, 100, 100, 50],
    5: [100, 100, 100, 100, 100]
  };


  ngOnInit() {
    this.stars = this.starsWidth[this.rating];
  }
}
